var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.55271368e-14,7.56686807 C3.55271368e-14,6.46720811 0.89222507,5.57575758 1.99086003,5.57575758 L23.92914,5.57575758 C25.0286616,5.57575758 25.92,6.47562359 25.92,7.56686807 L25.92,21.2412127 C25.92,22.3408727 25.0277749,23.2323232 23.92914,23.2323232 L1.99086003,23.2323232 C0.891338396,23.2323232 3.55271368e-14,22.3324572 3.55271368e-14,21.2412127 L3.55271368e-14,7.56686807 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockups---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teachers-folders",
    transform: "translate(-408.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(360.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder---hover",
    transform: "translate(20.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(28.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,7.74410774 L22.7692308,7.74410774 L0,7.74410774 L0,2.38280238 C0,1.06868687 1.104,-4.4408921e-15 2.46153846,-4.4408921e-15 L9.84615385,-4.4408921e-15 C9.99015385,-4.4408921e-15 10.1292308,0.0488474488 10.24,0.137606838 L13.7612308,2.97850298 L21.5384615,2.97850298 C22.896,2.97850298 24,4.04718985 24,5.36130536 L24,7.74410774 Z",
    id: "Page-1",
    fill: "#32AFE0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(12.960000, 14.404040) scale(-1, 1) translate(-12.960000, -14.404040) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#32AFE0",
    xlinkHref: "#path-1"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.f69b31ce.svg";
export { ForwardRef as ReactComponent };